<template>
  <div class="rule-item">
    <div class="rule-grid">
      <div class="rule-label">
        <font-awesome-icon :icon="['fas', 'tag']" class="rule-label-icon" />
        <span>Name</span>
      </div>

      <select
        v-if="ruleItem.type === 'Name'"
        v-model="ruleItem.comparison"
        class="ud-input ud-select form-select rule-select"
      >
        <option
          v-for="comparison in store.transactionNameComparisons"
          :key="comparison"
          :value="comparison"
        >
          {{ comparison }}
        </option>
      </select>

      <select
        v-if="ruleItem.type === 'Amount'"
        v-model="ruleItem.comparison"
        class="ud-input ud-select form-select rule-select"
      >
        <option
          v-for="amountComparison in store.transactionAmountComparisons"
          :key="amountComparison"
          :value="amountComparison"
        >
          {{ amountComparison }}
        </option>
      </select>

      <input
        type="text"
        class="ud-input rule-input"
        v-model="ruleItem.comparisonValue"
        placeholder="e.g. Netflix"
      />

      <button
        class="rule-delete-btn"
        @click="deleteCurrentRule"
        aria-label="Delete rule"
        type="button"
      >
        <font-awesome-icon :icon="['fas', 'trash']" />
      </button>
    </div>
  </div>
</template>

<script>
import { useMyStore } from '../store';
import { ref, watch, onMounted } from 'vue';

export default {
  name: 'CategorizationRule',
  props: {
    currentRule: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['addRule', 'updateRule', 'deleteRule'],
  setup(props, { emit }) {
    const store = useMyStore();
    const ruleItem = ref({
      type: 'Name',
      comparison: 'equals',
      comparisonValue: '',
    });

    watch(ruleItem.value, () => {
      emit('updateRule', ruleItem.value);
    });

    const deleteCurrentRule = () => {
      emit('deleteRule', ruleItem.value);
    };

    onMounted(() => {
      if (props.currentRule && Object.keys(props.currentRule).length > 0) {
        ruleItem.value = props.currentRule;
      }
    });

    return { store, ruleItem, deleteCurrentRule };
  },
};
</script>

<style scoped>
.rule-item {
  padding: 0.5rem 0;
  border-bottom: 1px solid #f0f0f0;
  animation: slideUp 0.2s ease both;
}
.dark-theme .rule-item {
  border-bottom-color: #2a3a4e;
}
.rule-item:last-child {
  border-bottom: none;
}

.rule-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
}

@media screen and (min-width: 500px) {
  .rule-grid {
    grid-template-columns: auto 1fr 2fr auto;
    align-items: center;
    gap: 8px;
  }
}

.rule-label {
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--purple-50);
  color: var(--color-accent-purple);
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 0.78rem;
  font-weight: 700;
  white-space: nowrap;
}
.dark-theme .rule-label {
  background: #1e1a40;
}
.rule-label-icon {
  font-size: 11px;
}

.rule-input::placeholder {
  color: #bbb;
}

.rule-delete-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #d85a30;
  font-size: 0.85rem;
  padding: 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    background var(--transition-fast),
    color var(--transition-fast);
  width: 36px;
  height: 36px;
  flex-shrink: 0;
}
.rule-delete-btn:hover {
  background: #faece7;
}
.dark-theme .rule-delete-btn {
  color: #f09595;
}
.dark-theme .rule-delete-btn:hover {
  background: rgba(240, 149, 149, 0.1);
}
</style>

<!-- <template>
  <div>
    <div class="rule-grid">
      <div class="flex align-center justify-center">Name</div>

      <select
        v-if="ruleItem.type === 'Name'"
        v-model="ruleItem.comparison"
        class="rule-dropdown form-select grey-form-select"
      >
        <option
          v-for="comparison in store.transactionNameComparisons"
          :key="comparison"
          :value="comparison"
        >
          {{ comparison }}
        </option>
      </select>

      <select
        v-if="ruleItem.type === 'Amount'"
        v-model="ruleItem.comparison"
        class="rule-dropdown form-select grey-form-select"
      >
        <option
          v-for="amountComparison in store.transactionAmountComparisons"
          :key="amountComparison"
          :value="amountComparison"
        >
          {{ amountComparison }}
        </option>
      </select>

      <input
        type="text"
        class="rule-grid-input"
        v-model="ruleItem.comparisonValue"
      />

      <div class="delete-rule pointer" @click="deleteCurrentRule">
        <font-awesome-icon :icon="['fas', 'trash']" />
      </div>
    </div>
  </div>
</template>

<script>
import { useMyStore } from '../store';
import { ref, watch, onMounted } from 'vue';

export default {
  name: 'Categorization-Rule',
  props: {
    currentRule: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['addRule', 'updateRule', 'deleteRule'],
  setup(props, { emit }) {
    const store = useMyStore();
    const ruleItem = ref({
      type: 'Name',
      comparison: 'equals',
      comparisonValue: '',
    });

    watch(ruleItem.value, () => {
      emit('updateRule', ruleItem.value);
    });

    const deleteCurrentRule = () => {
      emit('deleteRule', ruleItem.value);
    };

    onMounted(() => {
      if (props.currentRule && Object.keys(props.currentRule).length > 0) {
        ruleItem.value = props.currentRule;
      }
    });

    return {
      store,
      ruleItem,
      deleteCurrentRule,
    };
  },
};
</script>

<style scoped>
.rule-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.25em;
  margin: 0.5em 0;
}

.rule-dropdown,
.rule-grid-input {
  padding: 0.5em;
  border-radius: 10px;
  font-size: 1em;
  box-sizing: border-box;
  width: 100%;
}

.light-theme .rule-dropdown,
.light-theme .rule-grid-input {
  border: 1px solid #004751;
  color: #004751;
}

.dark-theme .rule-dropdown,
.dark-theme .rule-grid-input {
  border: 1px solid #212e3e;
  background: #212e3e;
  color: white;
}

.delete-rule {
  display: flex;
  justify-content: center;
  align-items: center;
}

.light-theme .delete-rule {
  color: #851e0d;
}

.dark-theme .delete-rule {
  color: #b61318;
}

@media screen and (min-width: 500px) {
  .rule-grid {
    grid-template-columns: 2fr 2fr 2fr 1fr;
  }
}
</style> -->
